import Link from "next/link";
import RightCaret from "public/right-caret.svg";
import { FC } from "react";
import constants from "utils/constants";
import { HelpCenterBreadcrumbs } from "utils/types";
import { useEventTracker_DEPRECATED } from "utils/useEventTracker";

interface BreadcrumbsInputs {
	breadcrumbs?: HelpCenterBreadcrumbs[];
}

const INDEX_OF_CATEGORY = 0;
const INDEX_OF_SECTION = 1;

const Breadcrumbs: FC<BreadcrumbsInputs> = ({ breadcrumbs }) => {
	const trackCategoryOnClick = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_CATEGORY_SELECTION
	);
	const trackSectionOnClick = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_SECTION_SELECTION
	);
	const handleCategoryOnClick = (categoryName: string) => {
		trackCategoryOnClick({ "Help Center Category": categoryName });
	};

	const handleSectionOnClick = (sectionName: string) => {
		trackSectionOnClick({ "Help Center Section": sectionName });
	};

	return (
		<div className="help-center-breadcrumbs">
			{Boolean(breadcrumbs?.length) && (
				<>
					<span className="breadcrumb-link">
						<Link href="/help">Help Center</Link>
					</span>
					<span className="help-center-right-caret">
						<RightCaret />
					</span>
					{breadcrumbs?.map((val, index) => {
						return (
							<span key={val.name + index}>
								<span className="breadcrumb-link">
									{val.link ? (
										index === INDEX_OF_CATEGORY ? (
											<Link
												href={val.link}
												onClick={() => handleCategoryOnClick(val.name)}>
												{val.name}
											</Link>
										) : index === INDEX_OF_SECTION ? (
											<Link
												href={val.link}
												onClick={() => handleSectionOnClick(val.name)}>
												{val.name}
											</Link>
										) : (
											<Link href={val.link}>{val.name}</Link>
										)
									) : (
										<>{val.name}</>
									)}
								</span>
								{breadcrumbs.length - 1 !== index && (
									<span className="help-center-right-caret">
										<RightCaret />
									</span>
								)}
							</span>
						);
					})}
				</>
			)}
		</div>
	);
};
export default Breadcrumbs;
